import { Box, Typography, InputBase } from '@mui/material'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'

// A simple notes card.
//
// Ensure setNotes does not trigger a re-render on this component, otherwise
// the cursor will consistently lose focus.
const RPNotes = ({ notes, setNotes, isStarted = false, onLearningPath = false }) => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
      }}>
      <Typography fontWeight={600}>{t('common.notes')}</Typography>
      <InputBase
        type='text'
        multiline
        value={notes}
        placeholder={t('rolePlay.notesPlaceholder')}
        onChange={e => setNotes(e.target.value)}
        sx={{
          flexGrow: 1,
          borderWidth: '1px',
          borderColor: colors.Grey200,
          borderStyle: 'solid',
          borderRadius: 4,
          padding: 8,
          maxHeight: 260,
          alignItems: 'flex-start',
          '& textarea': {
            flexGrow: 1,
            height: isStarted || onLearningPath ? '100% !important' : '135px !important',
            overflow: 'auto !important'
          },
          '&:hover': { borderColor: colors.Teal400 },
          '&:focus-within': {
            borderColor: colors.Teal400,
            borderWidth: 2
          }
        }}
      />
    </Box>
  )
}

export default RPNotes
